import { Injectable } from "@angular/core";
import { Haptics, NotificationType } from "@capacitor/haptics";
import { HapticsProvider, HapticType } from "./haptics.provider";

@Injectable({ providedIn: 'root' })
export class ScreenAnimationProvider {
    public isWave: boolean;
    public isShake: boolean;
    public isSwipeLeft: boolean;
    public wasSwipeLeft: boolean = false;

    public isSwipeDown: boolean;
    public wasSwipeDown: boolean = false;

    private shakeTimeout: any;
    private waveTimeout: any;

    constructor(private hapticsProvider: HapticsProvider) { }

    shake() {
        this.isShake = false;
        clearTimeout(this.shakeTimeout);
        this.isShake = true;
        Haptics.notification({ type: NotificationType.Error });
        this.shakeTimeout = setTimeout(() => this.isShake = false, 400);
    }

    async wave() {
        this.isWave = false;
        clearTimeout(this.waveTimeout);
        this.hapticsProvider.vibrate(HapticType.Click);
        this.isWave = true;
        this.waveTimeout = setTimeout(() => this.isWave = false, 600);
    }

    swipeLeft() {
        this.wasSwipeLeft = true;
        this.isSwipeLeft = true;
    }

    restoreSwipeLeft() {
        this.isSwipeLeft = false;
        setTimeout(() => this.wasSwipeLeft = false, 200);
    }

    swipeDown() {
        this.wasSwipeDown = true;
        this.isSwipeDown = true;
    }

    restoreSwipeDown() {
        this.isSwipeDown = false;
        setTimeout(() => this.wasSwipeDown = false, 400);
    }
}